export const CREATE_CHART = 'events/CREATE_CHART';

/**
 *
 * @param chart
 * @param height
 * @param width
 * @param dashboardId
 * @param intl
 * @param messages
 * @returns {{payload: {width, messages, intl, chart, height, dashboard_id}, type: string}}
 */
export const createChart = (chart, height, width, dashboardId, intl, messages) => ({
  type: CREATE_CHART,
  payload: {
    chart, height, width, dashboard_id: dashboardId, intl, messages,
  },
});
